export const isDevMode =
  process.env.NODE_ENV === 'development' ||
  process.env.IS_SLINGSHOT === 'true' ||
  process.env.NODE_ENV === 'test';

export const isNotProduction = process.env.NODE_ENV !== 'production';
